/* PLAKTON · pk-collection.js — cabecera y rejilla de colección */
(function () {
  'use strict';
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function init(root) {
    if (!root || root.dataset.pkReady) return;
    root.dataset.pkReady = '1';
    /* La barra puede vivir en la cabecera de la colección (se mueve al cargar): buscar en ambos sitios */
    var headBar = document.querySelector('[data-pk-cg-bar].is-in-head');
    function qa(sel) { var out = [].slice.call(root.querySelectorAll(sel)); if (headBar) out = out.concat([].slice.call(headBar.querySelectorAll(sel))); return out; }
    var drawer = root.querySelector('[data-pk-cg-drawer]');
    var opens = qa('[data-pk-cg-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('pk-cg-lock');
      opens.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var f = drawer.querySelector('.pk-cg__x'); if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('pk-cg-lock');
      opens.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { drawer.hidden = true; }, 320);
      if (lastFocus) lastFocus.focus();
    }
    opens.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-pk-cg-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

    /* Formulario: sin parámetros vacíos */
    var form = drawer.querySelector('form');
    form.addEventListener('submit', function () {
      form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    });

    /* Ordenar desde la barra */
    var sort = qa('[data-pk-cg-sort]')[0];
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });

    /* Columnas */
    var colsBtns = qa('[data-pk-cg-cols]');
    function setCols(n) {
      root.style.setProperty('--pk-cg-cols', n);
      colsBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-pk-cg-cols') === String(n)); });
    }
    var saved = store('pkCols');
    setCols(saved || getComputedStyle(root).getPropertyValue('--pk-cg-cols').trim() || 4);
    colsBtns.forEach(function (b) { b.addEventListener('click', function () { var n = b.getAttribute('data-pk-cg-cols'); setCols(n); store('pkCols', n); }); });

    /* Ver más sin recargar */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pk-cg-next]');
      if (!a) return;
      e.preventDefault();
      if (a.classList.contains('is-busy')) return;
      a.classList.add('is-busy');
      fetch(a.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-pk-cg-grid]');
        var newCells = doc.querySelectorAll('[data-pk-cg-grid] > li');
        newCells.forEach(function (li, k) { li.style.setProperty('--i', k); grid.appendChild(document.importNode(li, true)); });
        var oldMore = root.querySelector('[data-pk-cg-more]');
        var newMore = doc.querySelector('[data-pk-cg-more]');
        if (newMore) oldMore.replaceWith(document.importNode(newMore, true)); else oldMore.remove();
        document.dispatchEvent(new CustomEvent('pk:products-added', { detail: { root: grid } }));
      }).catch(function () { location.href = a.href; });
    });

    /* Botón flotante en móvil cuando la barra ya no se ve */
    var bar = root.querySelector('[data-pk-cg-bar]') || headBar;
    var fl = root.querySelector('.pk-cg__float');
    if (bar && fl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { fl.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(bar);
    }
  }

  function boot() { document.querySelectorAll('[data-pk-cg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-pk-cg]')); });
})();
